export default function (props: any) {
    return (
        <svg width="39px" height="38px" viewBox="0 0 39 38" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="DELTA-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Coffee-maker-_icon" transform="translate(0.016245, 0.000000)">
                    <rect id="矩形" x="0" y="0" width="38" height="38"></rect>
                    <g id="编组-44" transform="translate(2.730679, 2.826555)" stroke="#FFFFFF" strokeLinejoin="round" strokeWidth="1.44051283">
                        <path
                            d="M0,32.3468903 L13.0623213,32.3468903 L13.0623213,0 L9.06553948,0 C4.0588878,0 0,4.05824086 0,9.06553948 L0,32.3468903 Z"
                            id="Stroke-85"
                        ></path>
                        <path
                            d="M23.3146681,2.87770875 L13.0626447,2.87770875 L13.0626447,10.562683 L27.8089451,10.562683 L27.8089451,7.37198569 C27.8089451,4.88968533 25.7969685,2.87770875 23.3146681,2.87770875 Z"
                            id="Stroke-86"
                        ></path>
                        <path
                            d="M29.3958188,27.2816261 L13.06258,27.2816261 L13.06258,32.1207209 L32.5386427,32.1207209 L32.5386427,30.4244499 C32.5386427,28.6887158 31.131553,27.2816261 29.3958188,27.2816261 Z"
                            id="Stroke-87"
                        ></path>
                        <path
                            d="M26.8627339,23.0016796 C26.8627339,25.3655904 24.9465041,27.2818202 22.5825933,27.2818202 C20.2186826,27.2818202 18.3024528,25.3655904 18.3024528,23.0016796 L18.3024528,20.1441553 L26.8627339,20.1441553 L26.8627339,22.2454093 L26.8627339,23.0016796 Z"
                            id="Stroke-88"
                        ></path>
                        <line x1="29.9454572" y1="22.3060921" x2="26.8627985" y2="22.3060921" id="Stroke-89" strokeLinecap="round"></line>
                        <polygon id="Stroke-90" points="20.6427503 13.931094 24.0113555 13.931094 24.0113555 10.5624889 20.6427503 10.5624889"></polygon>
                        <line x1="4.20617638" y1="5.33658997" x2="9.11310857" y2="5.33658997" id="Stroke-91" strokeLinecap="round"></line>
                        <line x1="4.20617638" y1="8.23014869" x2="9.11310857" y2="8.23014869" id="Stroke-92" strokeLinecap="round"></line>
                        <path
                            d="M9.11310857,22.3967281 C9.11310857,23.7520343 8.01494872,24.8501942 6.65964248,24.8501942 C5.30489282,24.8501942 4.20617638,23.7520343 4.20617638,22.3967281 C4.20617638,21.0414218 5.30489282,19.943262 6.65964248,19.943262 C8.01494872,19.943262 9.11310857,21.0414218 9.11310857,22.3967281 Z"
                            id="Stroke-93"
                            strokeLinecap="round"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
